var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1679(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1679",
    "data-name": "Groupe 1679",
    transform: "translate(-13228 -995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1289",
    "data-name": "Rectangle 1289",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(13228 995)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_element-2",
    "data-name": "vuesax/linear/element-2",
    transform: "translate(12702 778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "element-2",
    transform: "translate(556 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.882,27.129V3.183C12.882.909,11.912,0,9.5,0H3.38C.97,0,0,.909,0,3.183V27.129c0,2.273.97,3.183,3.38,3.183H9.5C11.912,30.312,12.882,29.4,12.882,27.129Z",
    transform: "translate(3.031 3.031)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M12.882,9.882V3c0-2.137-.97-3-3.38-3H3.38C.97,0,0,.864,0,3V9.866c0,2.152.97,3,3.38,3H9.5C11.912,12.882,12.882,12.019,12.882,9.882Z",
    transform: "translate(20.46 3.031)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M12.882,9.5V3.38C12.882.97,11.912,0,9.5,0H3.38C.97,0,0,.97,0,3.38V9.5c0,2.41.97,3.38,3.38,3.38H9.5C11.912,12.882,12.882,11.912,12.882,9.5Z",
    transform: "translate(20.46 20.46)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H36.374V36.374H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1679);
export default __webpack_public_path__ + "static/media/Groupe-1679.09be9c021d0d19db092a51ed407c47a7.svg";
export { ForwardRef as ReactComponent };